import { render, staticRenderFns } from "./CriancasMulheresIcon.vue?vue&type=template&id=4b3f3c40"
import script from "./CriancasMulheresIcon.vue?vue&type=script&lang=js"
export * from "./CriancasMulheresIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports